import React, { Component } from 'react';
import { connect } from 'react-redux';
import { hideModal } from '../../../actions/modal';

class AddressRemovalPopup extends Component {
  constructor(props) {
    super(props);
    this.textContent = {
      deleteMessage: 'Are you sure you want to delete the address ?',
      deletBtnText: 'OK',
      cancelBtnText: 'Cancel'
    };
  }

  render() {
    const { modalName = '' } = this.props;

    return (
      <div className="self-ship-popup">
        <p>How to self ship</p>
        <div>
          In a closed sealed bag, please include
          <ol className="self-ship-list">
            <li>The products(s)</li>
            <li>All tags/original packet</li>
            <li>Piece of paper consisting of Order Id and Return Id</li>
          </ol>
        </div>
        <div className="self-ship-footer-text">
          Ship the products to the address that will be specified to you once you create the return.
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    hideModal: name => {
      dispatch(hideModal(name));
    }
  };
};

export default connect(null, mapDispatchToProps)(AddressRemovalPopup);
